import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

const CustomDrag = styled.div`
  display: flex;
  width: 20px;
  height: 40px;
  position: absolute;
  cursor: grab;
  right: ${((props) => props.spaceRight || '3%')};
  margin-top: ${((props) => props.marginTop || '23px')};
  z-index: 1;
`;

const DragIcon = styled(Icon)`
  color: #4D5473;
  font-size: 16px !important;
`;

const Item = styled.div`
  margin: ${((props) => (props.noMargin ? '0' : '20px 0'))};
  position: relative;
`;

export {
  CustomDrag,
  DragIcon,
  Item,
};
